import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(r => r, async (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  if (error.response?.status === 401 && !cfg._retry && !["/auth/login", "/auth/refresh"].some(u => url.endsWith(u))) {
    cfg._retry = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    try { await refreshing; return api(cfg); } catch { return Promise.reject(error); }
  }
  return Promise.reject(error);
});

export const money = (v) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(v || 0);
export const money2 = (v) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(v || 0);
export const TX_TYPES = [["income", "Peşin satış / gelir"], ["credit_sale", "Vadeli satış (hesaba yaz)"], ["collection", "Tahsilat"], ["expense", "Gider (peşin)"], ["credit_purchase", "Vadeli alış (borca yaz)"], ["supplier_payment", "Cari / tedarikçi ödemesi"], ["advance", "Personel avansı"]];
export const INFLOW = ["income", "credit_sale", "collection"];
export const NEEDS_CONTACT = ["credit_sale", "collection", "credit_purchase", "supplier_payment", "advance"];
export const TX_LABEL = { income: "Peşin satış", credit_sale: "Vadeli satış", collection: "Tahsilat", expense: "Gider", credit_purchase: "Vadeli alış", supplier_payment: "Cari ödemesi", advance: "Personel avansı", transfer: "Borç ödemesi" };
export const addDaysIso = (d, n) => { const x = new Date(`${d}T12:00:00`); x.setDate(x.getDate() + n); return x.toISOString().slice(0, 10); };
export const LEDGER_CATEGORIES = [
  { name: "Müşteri tahsilatı", kind: "collection", group: "Giriş", contact: true },
  { name: "Peşin satış", kind: "income", group: "Giriş" },
  { name: "Vadeli satış", kind: "credit_sale", group: "Giriş", contact: true },
  { name: "Diğer gelir", kind: "income", group: "Giriş" },
  { name: "Tedarikçi ödemesi", kind: "supplier_payment", group: "Çıkış", contact: true },
  { name: "Vadeli alış (tedarikçi)", kind: "credit_purchase", group: "Çıkış", contact: true },
  { name: "Malzeme / hammadde alımı", kind: "expense", group: "Çıkış" },
  { name: "Sarf malzeme alımı", kind: "expense", group: "Çıkış" },
  { name: "Personel ödemesi (maaş)", kind: "expense", group: "Çıkış" },
  { name: "Personel avansı", kind: "advance", group: "Çıkış", contact: true },
  { name: "Kredi ödemesi", kind: "expense", group: "Çıkış" },
  { name: "Faiz ödemesi", kind: "expense", group: "Çıkış" },
  { name: "Vergi ödemesi (GİB)", kind: "expense", group: "Çıkış" },
  { name: "SGK prim ödemesi", kind: "expense", group: "Çıkış" },
  { name: "Yemek ve ofis giderleri", kind: "expense", group: "Çıkış" },
  { name: "Nakliye gideri", kind: "expense", group: "Çıkış" },
  { name: "Araç yakıt gideri", kind: "expense", group: "Çıkış" },
  { name: "Araç bakım gideri", kind: "expense", group: "Çıkış" },
  { name: "Genel", kind: null, group: "Diğer" },
];
export const KIND_DEFAULT_CATEGORY = { income: "Peşin satış", credit_sale: "Vadeli satış", collection: "Müşteri tahsilatı", expense: "Genel", credit_purchase: "Vadeli alış (tedarikçi)", supplier_payment: "Tedarikçi ödemesi", advance: "Personel avansı" };
export const CONTACT_KIND = { customer: "Müşteri", supplier: "Tedarikçi", employee: "Personel", partner: "Ortak / şahıs" };
export const PAY_METHODS = [];
export const BANKS = [];
export const COMPANY = { name: "Demkan Makina", app_name: "Demkan Finans" };
const replace = (arr, items) => arr.splice(0, arr.length, ...items);
export const applySettings = (s) => {
  replace(LEDGER_CATEGORIES, s.categories.map(c => ({ ...c, kind: c.kind || null })));
  Object.keys(CONTACT_KIND).forEach(k => delete CONTACT_KIND[k]);
  s.contact_kinds.forEach(k => { CONTACT_KIND[k.key] = k.label; });
  Object.keys(KIND_DEFAULT_CATEGORY).forEach(k => {
    if (!LEDGER_CATEGORIES.some(c => c.name === KIND_DEFAULT_CATEGORY[k])) KIND_DEFAULT_CATEGORY[k] = (LEDGER_CATEGORIES.find(c => c.kind === k) || LEDGER_CATEGORIES.find(c => !c.kind) || LEDGER_CATEGORIES[0]).name;
  });
  replace(PAY_METHODS, s.pay_methods.map(p => p.name));
  replace(BANKS, s.banks.map(b => b.name));
  Object.assign(COMPANY, s.company);
  document.title = s.company.app_name;
};
export const today = () => new Date().toISOString().slice(0, 10);
export const errorText = (e, fallback = "İşlem tamamlanamadı") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d) && d[0]?.msg) {
    const m = d[0].msg.replace(/^Value error, /, "");
    const min = m.match(/at least (\d+) character/);
    return min ? `En az ${min[1]} karakter girin` : m;
  }
  return typeof d === "string" ? d : fallback;
};

export async function downloadReport(params) {
  const r = await api.get("/reports/export", { params, responseType: "blob" });
  const name = (r.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/)?.[1] || `demkan-finans.${params.fmt}`;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
